import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const testimonials = [
  {
    quote: "Guests were filming the floor all night. Every single person asked us where we found Luma. It was the highlight of the entire evening.",
    name: 'Sarah & Marcus',
    role: 'Wedding · London',
    rating: 5,
  },
  {
    quote: "We've tried every production company. Nothing comes close to what Luma delivers. Our venue went from a club to a destination overnight.",
    name: 'James Thornton',
    role: 'Nightclub Director · NYC',
    rating: 5,
  },
  {
    quote: "Our product launch was trending for 48 hours. Journalists, influencers, everyone was filming the floor. Luma made our brand an experience.",
    name: 'Priya Mehta',
    role: 'Brand Director · Tokyo',
    rating: 5,
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { delay: i * 0.12, duration: 0.65, ease: 'easeOut' },
  }),
};

export const SocialProof = () => (
  <section
    id="social-proof"
    data-testid="social-proof-section"
    className="relative py-28 lg:py-36 px-6 overflow-hidden"
    style={{ background: '#0A0A0A' }}
  >
    {/* Side glow */}
    <div
      className="absolute -left-32 top-1/2 -translate-y-1/2 w-64 h-96 pointer-events-none"
      style={{
        background: 'radial-gradient(ellipse, rgba(139,92,246,0.12) 0%, transparent 70%)',
        filter: 'blur(40px)',
      }}
    />

    <div className="max-w-7xl mx-auto">
      {/* Testimonials header */}
      <div className="mb-12 lg:mb-16">
        <motion.p
          initial="hidden" whileInView="visible" viewport={{ once: true }}
          variants={fadeUp}
          className="text-xs font-manrope tracking-[0.3em] uppercase text-luma-purple mb-4"
        >
          What People Say
        </motion.p>
        <motion.h2
          initial="hidden" whileInView="visible" viewport={{ once: true }}
          variants={fadeUp} custom={1}
          className="font-outfit font-bold text-4xl sm:text-5xl leading-none tracking-tight text-white"
          data-testid="testimonials-headline"
        >
          "Highlight of the night."
        </motion.h2>
      </div>

      {/* Testimonials grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {testimonials.map((t, i) => (
          <motion.div
            key={t.name}
            data-testid={`testimonial-${i}`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
            custom={i + 2}
            className="glass-card card-hover rounded-2xl p-8"
            style={{ border: '1px solid rgba(255,255,255,0.06)' }}
          >
            {/* Stars */}
            <div className="flex gap-1 mb-6">
              {Array.from({ length: t.rating }).map((_, si) => (
                <Star key={si} size={14} fill="#8B5CF6" stroke="none" />
              ))}
            </div>
            {/* Quote */}
            <p className="font-manrope text-sm text-white/75 leading-relaxed mb-8 italic">
              "{t.quote}"
            </p>
            {/* Attribution */}
            <div>
              <p className="font-manrope font-semibold text-sm text-white">{t.name}</p>
              <p className="font-manrope text-xs text-white/40 mt-1">{t.role}</p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Viral messaging */}
      <motion.div
        initial="hidden" whileInView="visible" viewport={{ once: true }}
        variants={fadeUp} custom={5}
        className="mt-16 text-center"
      >
        <p className="font-manrope text-sm text-white/35 tracking-[0.2em] uppercase">
          Guests filming constantly · Viral moments · "The one everyone is talking about"
        </p>
      </motion.div>
    </div>
  </section>
);

export default SocialProof;
